export default __webpack_public_path__ + "static/media/passbolt.4b7d3b17.svg";